import { memo } from "react";
import AuthLogo from "@/pages/Auth/components/AuthLogo";
import {
  getJourneyStepIndex,
  ROLE_CONTENT,
  type AuthRole,
  type JourneyStep,
  type JourneyStepKey,
} from "@/pages/Auth/authConfig";
import styles from "./Sidebar.module.scss";

interface SidebarProps {
  role: AuthRole;
  activeStep: JourneyStepKey;
  visibleSteps?: JourneyStep[] | undefined;
}

const Sidebar = ({ role, activeStep, visibleSteps }: SidebarProps) => {
  const steps = visibleSteps || ROLE_CONTENT[role].signUpSteps;
  const activeIndex = getJourneyStepIndex(steps, activeStep);

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarInner}>
        <div className={styles.brandBlock}>
          <AuthLogo className={styles.logo} />
        </div>

        <div className={styles.stepList}>
          {steps.map((step, index) => {
            const isActive = step.key === activeStep;
            const isCompleted = index < activeIndex;

            return (
              <div
                key={step.key}
                className={`${styles.stepItem} ${isActive ? styles.stepItemActive : ""} ${
                  isCompleted ? styles.stepItemCompleted : ""
                }`}
              >
                {index < steps.length - 1 ? (
                  <span
                    aria-hidden="true"
                    className={`${styles.stepConnector} ${
                      isCompleted ? styles.stepConnectorCompleted : ""
                    }`}
                  />
                ) : null}

                <span
                  className={`${styles.stepNumber} ${
                    isActive ? styles.stepNumberActive : ""
                  } ${isCompleted ? styles.stepNumberCompleted : ""}`}
                >
                  {index + 1}
                </span>
                <span
                  className={`${styles.stepLabel} ${
                    isActive ? styles.stepLabelActive : ""
                  }`}
                >
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.glowLarge} />
      <div className={styles.glowSmall} />
    </aside>
  );
};

export default memo(Sidebar);
